import { useState } from "react";
import { heroStats, tickerLines, topicFilters } from "@/mocks/homeData";

export default function HeroSection() {
  const [keyword, setKeyword] = useState("");
  const [activeChip, setActiveChip] = useState("全部话题");

  const handleChip = (tag: string) => {
    setActiveChip(tag);
    setKeyword(tag === "全部话题" ? "" : tag);
  };

  return (
    <section id="top" className="w-full bg-background-50">
      <div className="w-full overflow-hidden border-b border-accent-200 bg-accent-50">
        <div className="mx-auto flex w-full items-center gap-4 px-4 py-2 md:px-8">
          <span className="flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-2.5 py-1 text-xs font-medium text-background-50">
            <span className="flex h-1.5 w-1.5 animate-pulse-dot items-center justify-center rounded-full bg-background-50"></span>
            实时快讯
          </span>
          <div className="relative flex-1 overflow-hidden">
            <div className="flex w-max animate-marquee items-center gap-10">
              {[...tickerLines, ...tickerLines].map((line, index) => (
                <span
                  key={`${line.label}-${index}`}
                  className="flex items-center gap-2 whitespace-nowrap text-xs text-accent-900"
                >
                  <span className="rounded-sm bg-accent-200 px-1.5 py-0.5 font-medium">{line.label}</span>
                  {line.text}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="mx-auto w-full px-4 pb-16 pt-14 md:px-8 md:pb-20 md:pt-20">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-12 lg:gap-14">
          <div className="animate-fade-up lg:col-span-7">
            <div className="inline-flex items-center gap-2 rounded-full border border-background-200 bg-background-100 px-3 py-1.5">
              <span className="flex h-4 w-4 items-center justify-center text-primary-500">
                <i className="ri-fire-line text-sm"></i>
              </span>
              <span className="font-label text-xs font-medium tracking-wide text-foreground-700">
                圈子 · 话题 · 标签 · 群组 一体化聚合
              </span>
            </div>

            <h2 className="mt-5 font-heading text-3xl font-black leading-[1.28] tracking-tight text-foreground-950 text-balance md:text-5xl md:leading-[1.2]">
              黑料社区，把<span className="text-primary-500">热门话题</span>与
              <span className="text-primary-500">圈子分区</span>收进一条时间线
            </h2>

            <p className="mt-5 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
              黑料社区按圈子与话题分区，群组内集中讨论同一类爆料，标签快速筛选内容，热门话题实时更新。进入对应分区，找到同好一起深挖，话题脉络更清晰。
            </p>

            <form
              className="mt-7 flex flex-col gap-3 sm:flex-row"
              onSubmit={(event) => event.preventDefault()}
            >
              <div className="relative flex flex-1 items-center">
                <span className="pointer-events-none absolute left-4 flex h-5 w-5 items-center justify-center text-foreground-400">
                  <i className="ri-search-2-line"></i>
                </span>
                <input
                  type="text"
                  value={keyword}
                  onChange={(event) => setKeyword(event.target.value)}
                  placeholder="搜索圈子 / 话题 / 标签，例如：剪辑争议"
                  className="h-12 w-full rounded-lg border border-background-200 bg-background-50 pl-11 pr-4 text-sm text-foreground-800 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400"
                />
              </div>
              <button
                type="submit"
                className="flex h-12 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-lg bg-primary-500 px-6 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
                进入分区
              </button>
            </form>

            <div className="mt-4 flex flex-wrap items-center gap-2">
              <span className="text-xs text-foreground-400">热门筛选</span>
              {topicFilters.map((tag) => (
                <button
                  key={tag}
                  type="button"
                  onClick={() => handleChip(tag)}
                  className={`cursor-pointer whitespace-nowrap rounded-full border px-3 py-1.5 text-xs font-medium transition-colors ${
                    activeChip === tag
                      ? "border-primary-500 bg-primary-500 text-background-50"
                      : "border-background-200 bg-background-50 text-foreground-600 hover:border-primary-300 hover:text-primary-600"
                  }`}
                >
                  {tag}
                </button>
              ))}
            </div>

            {keyword ? (
              <p className="mt-3 text-xs text-foreground-500">
                正在按「<span className="font-medium text-primary-600">{keyword}</span>」聚合相关话题与标签
              </p>
            ) : null}

            <div className="mt-8 flex flex-wrap items-center gap-3">
              <a
                href="#topics"
                className="flex h-11 items-center gap-2 whitespace-nowrap rounded-lg bg-foreground-950 px-5 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800"
              >
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-live-line"></i>
                </span>
                浏览热门快讯流
              </a>
              <a
                href="#download"
                className="flex h-11 items-center gap-2 whitespace-nowrap rounded-lg border border-background-300 bg-background-50 px-5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
              >
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-download-2-line"></i>
                </span>
                下载 App 入口
              </a>
            </div>

            <dl className="mt-10 grid grid-cols-2 gap-5 border-t border-background-200 pt-6 md:grid-cols-4">
              {heroStats.map((stat) => (
                <div key={stat.label} className="flex items-start gap-3">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
                    <i className={`${stat.icon} text-lg`}></i>
                  </span>
                  <div>
                    <dt className="text-xs text-foreground-500">{stat.label}</dt>
                    <dd className="font-heading text-xl font-bold text-foreground-950">
                      {stat.value}
                      <span className="ml-0.5 text-xs font-normal text-foreground-500">{stat.suffix}</span>
                    </dd>
                  </div>
                </div>
              ))}
            </dl>
          </div>

          <div className="relative animate-fade-up lg:col-span-5" style={{ animationDelay: "120ms" }}>
            <div className="relative h-[360px] w-full overflow-hidden rounded-2xl border border-background-200 bg-background-100 md:h-[440px]">
              <img
                src="https://readdy.ai/api/search-image?query=stacked%20editorial%20magazine%20covers%20collage%20on%20warm%20cream%20background%2C%20abstract%20warm%20shapes%2C%20soft%20diffused%20light%2C%20muted%20vermillion%20and%20amber%20accents%2C%20minimal%20art%20direction%2C%20high%20detail&width=900&height=1000&seq=hero-collage-01&orientation=portrait"
                alt="黑料社区 圈子话题标签聚合 视觉封面"
                title="黑料社区 热门话题 圈子分区 标签群组聚合"
                className="h-full w-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/45 via-transparent to-transparent"></div>
              <span className="absolute right-4 top-4 flex items-center gap-1.5 whitespace-nowrap rounded-full bg-background-50/90 px-3 py-1.5 text-xs font-medium text-foreground-800 backdrop-blur">
                <span className="flex h-3 w-3 items-center justify-center text-primary-500">
                  <i className="ri-radar-line"></i>
                </span>
                话题实时更新
              </span>
            </div>

            <div className="absolute bottom-4 left-4 right-4 rounded-xl border border-background-200 bg-background-50/95 p-4 backdrop-blur">
              <div className="flex items-center justify-between">
                <span className="flex items-center gap-1.5 text-xs font-medium text-foreground-700">
                  <span className="flex h-1.5 w-1.5 animate-pulse-dot items-center justify-center rounded-full bg-primary-500"></span>
                  正在热聊
                </span>
                <span className="text-[11px] text-foreground-400">每 30 秒刷新</span>
              </div>
              <ul className="mt-3 space-y-2">
                <li className="flex items-center gap-2 text-xs text-foreground-600">
                  <span className="font-label tabular-nums text-foreground-400">09:42</span>
                  <span className="truncate">影视幕后 · 剪辑版本对照持续更新</span>
                </li>
                <li className="flex items-center gap-2 text-xs text-foreground-600">
                  <span className="font-label tabular-nums text-foreground-400">09:15</span>
                  <span className="truncate">综艺风向 · 录制排期出现变动</span>
                </li>
                <li className="flex items-center gap-2 text-xs text-foreground-600">
                  <span className="font-label tabular-nums text-foreground-400">08:58</span>
                  <span className="truncate">品牌内幕 · 配料表逐条对比</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}